<template>
    <div>
        <PrivacyPolicyComponent />
    </div>
</template>

<script>
import PrivacyPolicyComponent from '../components/PrivacyPolicyComponent.vue';
export default {
    name: 'PrivacyPolicyPage',
    components: {
        PrivacyPolicyComponent
    }
}
</script>
<style scoped>

</style>